// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ── Form sections ──────────────────────────────────────────────── */

.horse-edit-form {
  padding: 0.25rem 0;
}

.form-section {
  margin-bottom: 1.5rem;
}

.form-section-label {
  font-size: 0.6rem;
  font-weight: 700;
  letter-spacing: 0.1em;
  color: #9ca3af;
  text-transform: uppercase;
  border-bottom: 1px solid #f3f4f6;
  padding-bottom: 0.35rem;
  margin-bottom: 0.75rem;
}

/* ── Field labels ────────────────────────────────────────────────── */

.field-label {
  display: block;
  font-size: 0.6875rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  color: #374151;
  margin-bottom: 0.25rem;
}

.field-hint {
  font-size: 0.75rem;
  color: #9ca3af;
  margin-top: 0.25rem;
}

.field-required {
  color: #dc2626;
  font-weight: 700;
  margin-left: 0.1rem;
}

/* ── Form control sizing ─────────────────────────────────────────── */

.form-control,
.form-select {
  font-size: 0.9rem;
  border-color: #e5e7eb;
  border-radius: 6px;
}

.form-control:focus,
.form-select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);
}

/* ── Height field ────────────────────────────────────────────────── */

.height-input-row {
  display: flex;
  gap: 0.5rem;
  align-items: stretch;
}

.height-input-row .form-control {
  flex: 1;
  min-width: 0;
}

.height-unit-group {
  flex-shrink: 0;
}

.height-unit-group .btn {
  font-size: 0.8rem;
  font-weight: 600;
  padding: 0.375rem 0.625rem;
  border-color: #e5e7eb;
}

.height-unit-group .btn-dark {
  background: rgb(0, 51, 51);
  border-color: rgb(0, 51, 51);
}

/* ── Date of birth selects ───────────────────────────────────────── */

.dob-selects {
  display: flex;
  gap: 0.375rem;
}

.dob-year  { flex: 3; min-width: 0; }
.dob-month { flex: 4; min-width: 0; }
.dob-day   { flex: 2; min-width: 0; }

.dob-selects .form-select {
  font-size: 0.875rem;
  padding-right: 1.5rem;
}

/* ── Sex warning ─────────────────────────────────────────────────── */

.sex-warning {
  margin-top: 0.375rem;
  padding: 0.5rem 0.625rem;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 6px;
}

.sex-warning-text {
  display: block;
  font-size: 0.75rem;
  color: #92400e;
  margin-bottom: 0.375rem;
}

.sex-quickpick {
  display: flex;
  gap: 0.375rem;
}

.sex-btn {
  font-size: 0.75rem;
  padding: 0.2rem 0.625rem;
  border-color: #d1d5db;
  color: #374151;
}

.sex-btn:hover {
  background: rgb(0, 51, 51);
  border-color: rgb(0, 51, 51);
  color: #fff;
}

/* ── Save row ────────────────────────────────────────────────────── */

.form-section-actions {
  padding-top: 0.25rem;
  display: flex;
  justify-content: flex-end;
}
`, "",{"version":3,"sources":["webpack://./src/app/components/horses/edit-horse/edit-horse.component.css"],"names":[],"mappings":"AAAA,sEAAsE;;AAEtE;EACE,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,cAAc;EACd,yBAAyB;EACzB,gCAAgC;EAChC,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA,uEAAuE;;AAEvE;EACE,cAAc;EACd,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,uEAAuE;;AAEvE;;EAEE,iBAAiB;EACjB,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;;EAEE,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,WAAW;EACX,oBAAoB;AACtB;;AAEA;EACE,OAAO;EACP,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;EAC1B,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;AAC9B;;AAEA,uEAAuE;;AAEvE;EACE,aAAa;EACb,aAAa;AACf;;AAEA,aAAa,OAAO,EAAE,YAAY,EAAE;AACpC,aAAa,OAAO,EAAE,YAAY,EAAE;AACpC,aAAa,OAAO,EAAE,YAAY,EAAE;;AAEpC;EACE,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA,uEAAuE;;AAEvE;EACE,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,0BAA0B;EAC1B,4BAA4B;EAC5B,WAAW;AACb;;AAEA,uEAAuE;;AAEvE;EACE,oBAAoB;EACpB,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":["/* ── Form sections ──────────────────────────────────────────────── */\n\n.horse-edit-form {\n  padding: 0.25rem 0;\n}\n\n.form-section {\n  margin-bottom: 1.5rem;\n}\n\n.form-section-label {\n  font-size: 0.6rem;\n  font-weight: 700;\n  letter-spacing: 0.1em;\n  color: #9ca3af;\n  text-transform: uppercase;\n  border-bottom: 1px solid #f3f4f6;\n  padding-bottom: 0.35rem;\n  margin-bottom: 0.75rem;\n}\n\n/* ── Field labels ────────────────────────────────────────────────── */\n\n.field-label {\n  display: block;\n  font-size: 0.6875rem;\n  font-weight: 600;\n  letter-spacing: 0.05em;\n  color: #374151;\n  margin-bottom: 0.25rem;\n}\n\n.field-hint {\n  font-size: 0.75rem;\n  color: #9ca3af;\n  margin-top: 0.25rem;\n}\n\n.field-required {\n  color: #dc2626;\n  font-weight: 700;\n  margin-left: 0.1rem;\n}\n\n/* ── Form control sizing ─────────────────────────────────────────── */\n\n.form-control,\n.form-select {\n  font-size: 0.9rem;\n  border-color: #e5e7eb;\n  border-radius: 6px;\n}\n\n.form-control:focus,\n.form-select:focus {\n  border-color: #6366f1;\n  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.12);\n}\n\n/* ── Height field ────────────────────────────────────────────────── */\n\n.height-input-row {\n  display: flex;\n  gap: 0.5rem;\n  align-items: stretch;\n}\n\n.height-input-row .form-control {\n  flex: 1;\n  min-width: 0;\n}\n\n.height-unit-group {\n  flex-shrink: 0;\n}\n\n.height-unit-group .btn {\n  font-size: 0.8rem;\n  font-weight: 600;\n  padding: 0.375rem 0.625rem;\n  border-color: #e5e7eb;\n}\n\n.height-unit-group .btn-dark {\n  background: rgb(0, 51, 51);\n  border-color: rgb(0, 51, 51);\n}\n\n/* ── Date of birth selects ───────────────────────────────────────── */\n\n.dob-selects {\n  display: flex;\n  gap: 0.375rem;\n}\n\n.dob-year  { flex: 3; min-width: 0; }\n.dob-month { flex: 4; min-width: 0; }\n.dob-day   { flex: 2; min-width: 0; }\n\n.dob-selects .form-select {\n  font-size: 0.875rem;\n  padding-right: 1.5rem;\n}\n\n/* ── Sex warning ─────────────────────────────────────────────────── */\n\n.sex-warning {\n  margin-top: 0.375rem;\n  padding: 0.5rem 0.625rem;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  border-radius: 6px;\n}\n\n.sex-warning-text {\n  display: block;\n  font-size: 0.75rem;\n  color: #92400e;\n  margin-bottom: 0.375rem;\n}\n\n.sex-quickpick {\n  display: flex;\n  gap: 0.375rem;\n}\n\n.sex-btn {\n  font-size: 0.75rem;\n  padding: 0.2rem 0.625rem;\n  border-color: #d1d5db;\n  color: #374151;\n}\n\n.sex-btn:hover {\n  background: rgb(0, 51, 51);\n  border-color: rgb(0, 51, 51);\n  color: #fff;\n}\n\n/* ── Save row ────────────────────────────────────────────────────── */\n\n.form-section-actions {\n  padding-top: 0.25rem;\n  display: flex;\n  justify-content: flex-end;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
